import React, { useState } from 'react';

import { UseFormReturn } from 'react-hook-form';
import { useEffectAsync } from '../../../helpers';
import LocalStorage from '../../../Services/LocalStorage';

export interface FormDraftProps {
	formMethods: UseFormReturn<any>;
	key: string;
	defaultValues: any;
}

const STORAGE_PREFIX = 'form_draft_';

export default function useFormDraft({
	formMethods,
	key,
	defaultValues,
}: FormDraftProps) {
	const [isSaving, setIsSaving] = useState(false);
	const [timer, setTimer] = useState(undefined);
	const [isStorageDataLoaded, setIsStorageDataLoaded] = useState(false);

	useEffectAsync(() => {
		setIsStorageDataLoaded(false);
		if (!formMethods || !key) {
			return;
		}

		const data = LocalStorage.get(`${STORAGE_PREFIX}${key}`);

		formMethods.reset(data);
		setIsStorageDataLoaded(true);
	}, [formMethods, key]);

	React.useEffect(() => {
		const subscription = formMethods.watch(async (value, { name, type }) => {
			if (typeof value === 'undefined') {
				return;
			}

			if (timer) {
				clearTimeout(timer);
			}

			const tempTimer = setTimeout(() => {
				setIsSaving(true);
				if (Object.keys(value).length) {
					LocalStorage.set(`${STORAGE_PREFIX}${key}`, value);
				}
				setTimeout(() => {
					setIsSaving(false);
				}, 1000);
			}, 500);
			// @ts-ignore
			setTimer(tempTimer);
		});
		return () => subscription.unsubscribe();
	}, [formMethods?.watch]);

	const reset = (force = true) => {
		if (force) {
			LocalStorage.remove(`${STORAGE_PREFIX}${key}`);
		} else {
			const data = LocalStorage.get(`${STORAGE_PREFIX}${key}`);
			formMethods.reset(data || defaultValues || {});
		}
	};

	return {
		resetFormDraft: reset,
		formDraftIsSaving: isSaving,
		formDraftIsStorageDataLoaded: isStorageDataLoaded,
	};
}
